// extracted by mini-css-extract-plugin
module.exports = {"new-expense":"NewExpense_new-expense__2HlbK"};